import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersist from 'vuex-persist'
// import Cookies from 'js-cookie'

import auth from './auth/auth'
import nav from './navigation/nav'
import postStatus from './api/postStatus'
import searchModule from './search/searchModule'
import recentHistoryModule from './recent/recentHistoryModule'
import recentlyAccessedModule from './recent/recentlyAccessedModule'
import accountTypesModule from './administration/accountTypes/accountTypesModule'
import dashboardsModule from './dashboards/dashboardsModule'
import partnersModule from './administration/partners/partnersModule'
import findPartnersWidgetModule from './administration/partners/findPartnersWidgetModule'
import agenciesModule from './administration/agencies/agenciesModule'
import findAgenciesWidgetModule from './administration/agencies/findAgenciesWidgetModule'
import clientsModule from './administration/clients/clientsModule'
import findClientsWidgetModule from './administration/clients/findClientsWidgetModule'
import usersModule from './administration/users/usersModule'
import findUsersWidgetModule from './administration/users/findUsersWidgetModule'
import usersProfileModule from './administration/users/usersProfileModule'
import userRegisterModule from './accounts/userRegisterModule'
import usersSettingsModule from './accounts/usersSettingsModule'
import driversModule from './assets/drivers/driversModule'
import vehiclesModule from './assets/vehicles/vehiclesModule'
import vehicleExpensesModule from './assets/vehicle-expenses/vehicleExpensesModule'
import groupsModule from './groups/groupsModule'
import unitArchivesModule from './units/archives/unitArchivesModule'
import unitSwappingModule from './units/swapping/unitSwappingModule'
import unitsModule from './units/unitsModule'
import cfgTemplatesModule from './units/cfgTemplatesModule'
import unitSimCardsModule from '@/store/units/unitSimCardsModule'
import monitoringModule from './monitoring/monitoringModule'
import tripReplayWidgetModule from './monitoring/tripReplayWidgetModule'
import positionReplayWidgetModule from './monitoring/positionReplayWidgetModule'
import liveTrackingWidgetModule from './monitoring/liveTrackingWidgetModule'
import fleetWidgetModule from './monitoring/fleetWidgetModule'
import trackedVehiclesModule from '@/store/assets/vehicles/trackedVehiclesModule'
import findVehiclesWidgetModule from './assets/vehicles/findVehiclesWidgetModule'
import findDriversWidgetModule from './assets/drivers/findDriversWidgetModule'
import findGroupsWidgetModule from './groups/findGroupsWidgetModule'
import findUnitsWidgetModule from './units/findUnitsWidgetModule'
import unitTransferModule from './units/transfer/unitTransferModule'
import trackedUnitsModule from '@/store/units/trackedUnitsModule'
import widgetControlModule from '@/store/monitoring/widgetControlModule'
import reportsModule from '@/store/reports/reportsModule'
import findReportScheduleStatusModule from '@/store/reports/findReportScheduleStatusModule'
import eventProfilesModule from '@/store/events/profiles/eventProfilesModule'
import eventPoolsModule from '@/store/events/pools/eventPoolsModule'
import findEventPoolsWidgetModule from '@/store/events/pools/findEventPoolsWidgetModule'
import findWsEventPoolsWidgetModule from '@/store/events/pools/findWsEventPoolsWidgetModule'
import findEventProfilesWidgetModule from '@/store/events/profiles/findEventProfilesWidgetModule'
import eventMonitoringModule from '@/store/events/monitoring/eventMonitoringModule'
import findZonesWidgetModule from '@/store/zones/findZonesWidgetModule'
import zonesModule from '@/store/zones/zonesModule'
import findClientPoiWidgetModule from '@/store/poi/findClientPoiWidgetModule'
import clientPoiModule from '@/store/poi/clientPoiModule'
import websentinel from './websentinel/websentinel'
import simCardsModule from '@/store/sim-cards/simCardsModule'
import findSimCardsWidgetModule from '@/store/sim-cards/findSimCardsWidgetModule'
import gdspoSimCardsModule from '@/store/sim-cards/gdspo/gdspoSimCardsModule'
import gdspoFindSimCardsWidgetModule from '@/store/sim-cards/gdspo/gdspoFindSimCardsWidgetModule'
import commandsModule from '@/store/units/commands/commandsModule'
import commandPermissionsModule from '@/store/units/commands/commandPermissionsModule'
import commandSendingModule from '@/store/units/commands/commandSendingModule'
import commandSummaryModule from '@/store/units/commands/commandSummaryModule'
import apiBridgeWebfleetModule from '@/store/administration/apiBridges/apiBridgeWebfleetModule'
import apiBridgeRabbitMqModule from '@/store/administration/apiBridges/apiBridgeRabbitMqModule'
import assetTransferModule from '@/store/assets/asset-transfer/assetTransferModule'

Vue.use(Vuex)

// We use a cookie to store the auth/token data as it is
// recommended over using localStorage. Only the auth module
// will be persisted to cookies.
// The cookie will expire long after the server expires the
// token, the user login expiration is handled by the server.

// Due to perhaps CORS HTTP request issues storing the token
// in a session cookie does not work as the cookie is overwritten
//  by the default state every time a CORS request is made
// (we think). We will be using localStorage until we can figure
// out an alternative solution.

/*
const vuexCookie = new VuexPersist({
  key: 'destiny',
  restoreState: (key, storage) => Cookies.getJSON(key),
  saveState: (key, state, storage) => {
    Cookies.set(key, state, {
      expires: 365
    })
  },
  modules: [
    'auth'
  ]
})
*/

// Only the auth, api, navigation, recent and settings module's data is persisted
// IMPORTANT: VuexPersist does not work on sub-modules for some reason:
// If you try to save something line /admin/usersModule it will not work.
const vuexLocalStorage = new VuexPersist({
  key: 'destiny',
  storage: window.localStorage,
  modules: [
    'auth', 'api', 'navigation', 'recent', 'settings'
  ]
})

// The modules are defined as { namespaceA: moduleA, namespaceB: moduleB }
export default new Vuex.Store({
  modules: {
    auth: auth,
    navigation: nav,
    api: postStatus,
    search: searchModule,
    recent: {
      namespaced: true,
      modules: {
        history: recentHistoryModule,
        access: recentlyAccessedModule
      }
    },
    settings: usersSettingsModule,
    account: {
      namespaced: true,
      modules: {
        userRegisterModule: userRegisterModule
      }
    },
    dashboards: {
      namespaced: true,
      modules: {
        dashboardsModule: dashboardsModule
      }
    },
    admin: {
      namespaced: true,
      modules: {
        accountTypesModule: accountTypesModule,
        partnersModule: partnersModule,
        findPartnersWidgetModule: findPartnersWidgetModule,
        agenciesModule: agenciesModule,
        findAgenciesWidgetModule: findAgenciesWidgetModule,
        clientsModule: clientsModule,
        findClientsWidgetModule: findClientsWidgetModule,
        usersModule: usersModule,
        usersProfileModule: usersProfileModule,
        findUsersWidgetModule: findUsersWidgetModule,
        apiBridgeWebfleetModule: apiBridgeWebfleetModule,
        apiBridgeRabbitMqModule: apiBridgeRabbitMqModule
      }
    },
    assets: {
      namespaced: true,
      modules: {
        driversModule: driversModule,
        vehiclesModule: vehiclesModule,
        vehicleExpensesModule: vehicleExpensesModule,
        vehicleGroupsModule: groupsModule,
        trackedVehiclesModule: trackedVehiclesModule,
        findVehiclesWidgetModule: findVehiclesWidgetModule,
        findDriversWidgetModule: findDriversWidgetModule,
        findVehicleGroupsWidgetModule: findGroupsWidgetModule,
        assetTransferModule: assetTransferModule
      }
    },
    simCards: {
      namespaced: true,
      modules: {
        simCardsModule: simCardsModule,
        findSimCardsWidgetModule: findSimCardsWidgetModule,
        gdspoSimCardsModule: gdspoSimCardsModule,
        gdspoFindSimCardsWidgetModule: gdspoFindSimCardsWidgetModule
      }
    },
    units: {
      namespaced: true,
      modules: {
        unitsModule: unitsModule,
        unitArchivesModule: unitArchivesModule,
        unitSwappingModule: unitSwappingModule,
        unitGroupsModule: groupsModule,
        unitSimCardsModule: unitSimCardsModule,
        unitTransferModule: unitTransferModule,
        cfgTemplatesModule: cfgTemplatesModule,
        trackedUnitsModule: trackedUnitsModule,
        findUnitsWidgetModule: findUnitsWidgetModule,
        commandsModule: commandsModule,
        commandPermissionsModule: commandPermissionsModule,
        commandSendingModule: commandSendingModule,
        commandSummaryModule: commandSummaryModule
      }
    },
    monitoring: {
      namespaced: true,
      modules: {
        monitoringModule: monitoringModule,
        widgetControlModule: widgetControlModule,
        liveTrackingWidgetModule: liveTrackingWidgetModule,
        tripReplayWidgetModule: tripReplayWidgetModule,
        positionReplayWidgetModule: positionReplayWidgetModule,
        fleetWidgetModule: fleetWidgetModule
      }
    },
    zones: {
      namespaced: true,
      modules: {
        findZonesWidgetModule: findZonesWidgetModule,
        zonesModule: zonesModule
      }
    },
    poi: {
      namespaced: true,
      modules: {
        findClientPoiWidgetModule: findClientPoiWidgetModule,
        clientPoiModule: clientPoiModule
      }
    },
    reports: {
      namespaced: true,
      modules: {
        reportsModule: reportsModule,
        findReportScheduleStatusModule: findReportScheduleStatusModule
      }
    },
    events: {
      namespaced: true,
      modules: {
        eventProfilesModule: eventProfilesModule,
        eventPoolsModule: eventPoolsModule,
        findEventPoolsWidgetModule: findEventPoolsWidgetModule,
        findWsEventPoolsWidgetModule: findWsEventPoolsWidgetModule,
        findEventProfilesWidgetModule: findEventProfilesWidgetModule,
        eventMonitoringModule: eventMonitoringModule
      }
    },
    websentinel: websentinel
  },
  plugins: [vuexLocalStorage.plugin]
})



// WEBPACK FOOTER //
// ./src/store/index.js